import React from 'react';
import { styled } from 'styled-components';

interface Step {
  id: number;
  label: string;
  isDazzle: boolean;
}

const Steps: Step[] = [{
  id: 1,
  label: 'Suggestion Pending',
  isDazzle: true
}, {
  id: 2,
  label: 'Suggestion Approved / Published',
  isDazzle: false
}, {
  id: 3,
  label: 'Suggestion Confirmed',
  isDazzle: true
}, {
  id: 4,
  label: 'Order Placed',
  isDazzle: false
}, {
  id: 5,
  label: 'Payment Completed',
  isDazzle: false
}, {
  id: 6,
  label: 'Order Delivered',
  isDazzle: false
}]

const OrderStepper = ({ current }: { current: number}) => {
  return <Container>
    <TrackContainer>
      <Track />
      <TrackFill $progress={Math.max(0, (current - 1) / (Steps.length - 1) * 100)} />
    </TrackContainer>
    <DotsContainer>
      {
        Steps.map((step) => {
          const state = step.id < current ? 'completed' : step.id === current ? 'current' : 'future';
          return <DotContainer key={step.id}>
            <Dot $state={state} />
            <StepLabel $state={state}>{step.label}</StepLabel>
          </DotContainer>;
        })
      }
    </DotsContainer>
  </Container>
};

const Container = styled.div`
  width: 100%;
  position: relative;
  margin: 20px 0 40px;
`;

const TrackContainer = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
`;

const Track = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background: #E4E7EF;
  border-radius: 1px;
`;

const TrackFill = styled.div<{ $progress: number }>`
  position: absolute;
  width: ${({ $progress }) => $progress}%;
  height: 2px;
  background: linear-gradient(90deg, #02033B, #743D98, #AC326C);
  border-radius: 1px;
  transition: width 0.3s ease;
`;

const DotsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: absolute;
  top: -7px;
`;

const DotContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Dot = styled.div<{ $state: 'completed' | 'current' | 'future' }>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  ${({ $state }) => {
    switch ($state) {
      case 'completed':
        return 'background: linear-gradient(135deg, #02033B, #743D98); border: 2px solid transparent;';
      case 'current':
        return 'background: #008AFF; border: 2px solid #008AFF; box-shadow: 0 0 0 4px rgba(0, 138, 255, 0.2);';
      case 'future':
        return 'background: white; border: 2px solid #E4E7EF;';
    }
  }}
`;

const StepLabel = styled.div<{ $state: 'completed' | 'current' | 'future' }>`
  font-size: 11px;
  font-weight: ${({ $state }) => $state === 'current' ? '600' : '500'};
  color: ${({ $state }) => $state === 'future' ? '#8890A5' : '#5A6178'};
  text-align: center;
  max-width: 100px;
  line-height: 1.3;
`;

export default OrderStepper;
